<script lang="ts">
    
    import { Button, ButtonGroup, Icon, Table } from "sveltestrap";
    import type { QuestionOptionsObject } from "../global";
    import { v4 as uuidv4 } from 'uuid';
    import type { QuestionGrid } from "../Model/QuestionGrid";
    import Watch from "./Watch.svelte";
    import StateInput from "./StateInput.svelte";
    import { GridRow } from "../Model/GridRow";
    import { GridColumn } from "../Model/GridColumn";

    export let options: QuestionOptionsObject;

    let grid: QuestionGrid;

    $: grid = options.questionGrid;

    function addColumn(): void {
        const column = new GridColumn(
            uuidv4(),
            '',
            'text',
            false
        );
        grid.addColumn(column);
    }

    function addRow(): void {
        const row = new GridRow(uuidv4(), '');
        grid.addRow(row);
    }

    function removeColumn({ id }: GridColumn): void {
        grid.quitColumn(id);
    }

    function removeRow({ id }: GridRow): void {
        grid.quitRow(id);
    }

    function onColumnUp({ id }: GridColumn): void {
        grid.columnUp(id);
    }

    function onColumnDown({ id }: GridColumn): void {
        grid.columnDown(id);
    }

    function onRowDown({ id }: GridRow): void {
        grid.rowDown(id);
    }

    function onRowUp({ id }: GridRow): void {
        grid.rowUp(id);
    }

</script>

{#if grid}
<h5>Columnas</h5>

<Table>
    <thead>
        <tr>
            <th>Columna</th>
            <th>Tipo</th>
            <th>Requerido</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <Watch store={grid.columns} let:value={columns}>
            {#each columns as column}
                <tr>
                    <td>
                        <StateInput type="text" class="input-sm" store={column.name} />
                    </td>
                    <td>
                        <StateInput type="select" store={column.type}>
                            <option value="text">Texto</option>
                            <option value="date">Fecha</option>
                            <option value="amount">Cantidad</option>
                            <option value="check">Check</option>
                        </StateInput>
                    </td>
                    <td>
                        <StateInput type="checkbox" store={column.required} />
                    </td>
                    <td class="text-end">
                        <ButtonGroup size="sm">
                            <Button type="button" color="primary" outline on:click={() => onColumnDown(column)}><Icon name="arrow-down" /></Button>
                            <Button type="button" color="primary" outline on:click={() => onColumnUp(column)}><Icon name="arrow-up" /></Button>
                            <Button type="button" color="danger" on:click={() => removeColumn(column)}><Icon name="x" /></Button>
                        </ButtonGroup>
                    </td>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>

<Button type="button" size="sm" color="primary" on:click={addColumn}>
    <Icon name="plus" /> Añadir columna
</Button>

<h5 class="mt-4">Filas</h5>

<Table>
    <thead>
        <tr>
            <th>Pregunta</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <Watch store={grid.rows} let:value={rows}>
            {#each rows as row}
                <tr>
                    <td>
                        <StateInput type="text" class="input-sm" store={row.text} />
                    </td>
                    <td class="text-end">
                        <ButtonGroup size="sm">
                            <Button type="button" color="primary" outline on:click={() => onRowDown(row)}><Icon name="arrow-down" /></Button>
                            <Button type="button" color="primary" outline on:click={() => onRowUp(row)}><Icon name="arrow-up" /></Button>
                            <Button type="button" color="danger" on:click={() => removeRow(row)}><Icon name="x" /></Button>
                        </ButtonGroup>
                    </td>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>

<Button type="button" size="sm" color="primary" on:click={addRow}>
    <Icon name="plus" /> Añadir fila
</Button>
{/if}

